import React, { useEffect } from "react";
import _ from "lodash";
import { EVENT_PLANNING_PICK_PLAN } from "../../../plannerConfig";
import {
  FigureRow,
  PickPlanFigures,
  DaySectionContainer,
  DaySectionText,
  VerticalHeaderText,
  VerticalHeaderWrapper,
  ScrollableHorizontalContainer,
  PickPlanEntryColumn,
  DateContainer,
  RecruitmentPlanMainTableContainer,
} from "./styles";
import { MultiWeekPlannerMainContainer } from "../multiWeekStyles.common";
import LoadSpinnerOverlay from "../../LoadSpinner";
import { getLocaleNumber } from "../../../helpers";

const HeaderText = ({ text }) => (
  <VerticalHeaderText>{text}</VerticalHeaderText>
);

const FigureRowComponent = ({ shiftBlocks, data, dataKey, dataSet }) => {
  const PICK_VOLUME = "Planned Pick Volume";
  const TOTAL_VOL_TO_PICK = "Remaining Disp Vol to Pick";

  const getIsHighlighted = (block) =>
    dataKey === PICK_VOLUME && dataSet[TOTAL_VOL_TO_PICK][block] > data[block];

  const getIsBolded = (block) =>
    dataKey === TOTAL_VOL_TO_PICK && dataSet[PICK_VOLUME][block] < data[block];

  return (
    <FigureRow>
      {shiftBlocks.map((block, index) => (
        <PickPlanFigures
          highlighted={getIsHighlighted(block)}
          bolded={getIsBolded(block)}
          key={`FigureData${index}${data[block]}`}
        >
          {getLocaleNumber(data[block])}
        </PickPlanFigures>
      ))}
    </FigureRow>
  );
};

const PickEntry = ({ data, rowFlexAmount, date, shiftBlocks, dataKeys }) => {
  return (
    <PickPlanEntryColumn>
      <DateContainer>{date}</DateContainer>
      <DaySectionContainer>
        {shiftBlocks.map((block) => (
          <DaySectionText>{block}</DaySectionText>
        ))}
      </DaySectionContainer>
      <div
        style={{
          display: "flex",
          flex: rowFlexAmount,
          flexDirection: "column",
        }}
      >
        {dataKeys.map((key) => (
          <FigureRowComponent
            key={`figureRow${key}`}
            dataSet={data}
            shiftBlocks={shiftBlocks}
            data={data[key]}
            dataKey={key}
          />
        ))}
      </div>
    </PickPlanEntryColumn>
  );
};

const PickPlanView = ({
  api,
  store,
  fromDate,
  toDate,
  fromDateFilter,
  toDateFilter,
  durationAggregator,
  selectedScenarios,
  activeFrontendFilters,
}) => {
  const { data, loadingQueue } = store[EVENT_PLANNING_PICK_PLAN];

  const getParamStringForFilter = () => {
    const filteredFilters = activeFrontendFilters.filter((filter) => {
      const splitText = filter.split("-|");
      return splitText.length > 2;
    });
    const returnParamString = filteredFilters
      .map((filter) => {
        const splitFilter = filter.split("-|");
        const filterSectionString = splitFilter[1]
          .replaceAll(" ", "_")
          .toLowerCase();
        const filterValue = splitFilter[2];
        return `${filterSectionString}=${filterValue}`;
      })
      .join("&");
    return returnParamString;
  };

  getParamStringForFilter();

  const getPickPlanData = () => {
    const { get } = api;
    const buildSelectedScenariosString = selectedScenarios
      .map((scenario) => `scenario_id=${scenario.id}`)
      .join("&");
    if (fromDate && toDate) {
      get([EVENT_PLANNING_PICK_PLAN], {
        routeParams: {
          fromDate,
          toDate,
          fromDateFilter,
          toDateFilter,
          durationAggregator,
          scenarios: `${buildSelectedScenariosString}&`,
          additionalFilters: getParamStringForFilter(),
        },
      });
    }
  };

  useEffect(() => {
    getPickPlanData();
  }, [
    fromDate,
    toDate,
    fromDateFilter,
    toDateFilter,
    durationAggregator,
    selectedScenarios,
    activeFrontendFilters,
  ]);

  if (loadingQueue.length || _.isEmpty(data)) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
        }}
      >
        <LoadSpinnerOverlay text="Pick Plan Data Loading..." spinning={true} />
      </div>
    );
  }

  const getshiftBlocks = (durationAggregator) => {
    if (durationAggregator === "week") {
      return ["", "Entire Day", ""];
    } else {
      return ["Day", "Aft", "Ngt"];
    }
  };

  const shiftBlocks = getshiftBlocks(durationAggregator);

  const {
    TableA: { data: pickPlanData, dataKeys, dates },
  } = data;

  const dateAndDataKeys = ["Dates", "Shift Block", ...dataKeys];
  const rowFlexAmount = dataKeys.length;

  return (
    <MultiWeekPlannerMainContainer>
      <div
        style={{
          display: "flex",
          flex: 1,
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <RecruitmentPlanMainTableContainer>
          <VerticalHeaderWrapper>
            {dateAndDataKeys.map((key) => (
              <HeaderText key={key} text={key} />
            ))}
          </VerticalHeaderWrapper>
          <ScrollableHorizontalContainer>
            {dates.map((date) => {
              return (
                <PickEntry
                  data={pickPlanData[date]}
                  rowFlexAmount={rowFlexAmount}
                  date={date}
                  shiftBlocks={shiftBlocks}
                  dataKeys={dataKeys}
                />
              );
            })}
          </ScrollableHorizontalContainer>
        </RecruitmentPlanMainTableContainer>
      </div>
    </MultiWeekPlannerMainContainer>
  );
};

export default PickPlanView;
